import store from "../store/index";
import Vue from "vue";
import VueRouter from "vue-router";
import AdminTemplate from "../views/admin/AdminTemplate.vue";
import Home from "../views/Home.vue";
import Usuarios from "../views/catalogos/usuarios/list.vue";
import Clientes from "../views/catalogos/clientes/list.vue";
import Personal from "../views/catalogos/personal/List.vue";
import TipoUnidad from "../views/catalogos/tipounidad/List.vue";
import TipoServicio from "../views/catalogos/tiposervicio/List.vue";
import Folio from "../views/catalogos/folio/List.vue";
import Servicio from "../views/catalogos/servicio/List.vue";
import Equipos from "../views/catalogos/equipos/List.vue";
import Equipamiento from "../views/catalogos/equipamiento/List.vue";
import Concepto from "../views/catalogos/concepto/List.vue";
import Vehiculo from "../views/catalogos/vehiculo/List.vue";
import CategoriaVehiculo from "../views/catalogos/categoriavehiculo/List.vue";
import HorasLaborales from "../views/catalogos/horaslaborales/Form.vue";
import Sucursal from "../views/catalogos/sucursal/List.vue";
import CategoriaPersonal from "../views/catalogos/categoriapersonal/List.vue";
import FormUser from "../views/catalogos/usuarios/Form.vue";
import EmpresaLista from "../views/catalogos/empresas/List.vue";
import Login from "../views/segurity/Login.vue";
import ClienteSucursal from "../views/catalogos/clientesucursal/List.vue";
import ContratoClienteSucursal from "../views/catalogos/contratos/List.vue";
import ListUsu from "../views/catalogos/clientes/ListUsu.vue";
import Mapa from "../views/catalogos/mapa/Mapa.vue";
import PdfEquipo from "../views/catalogos/pdfequipo/List.vue";

import Despacho from "../views/modulos/despacho/despacho.vue";
import ServicioForm from "../views/modulos/servicios/FormView.vue";
import ListServicio from "../views/modulos/servicios/List.vue";
import calendar from "../views/modulos/despacho/calendar.vue";

import SubmenuAdmon from "../views/submenu/Admon.vue";
import CostosVarios from "../views/catalogos/costosvarios/List.vue";

import SubmenuCotizacion from "../views/submenu/Cotizacion.vue";
import Cotizacion_Materiales from "../views/catalogos/cotizacion/material/List.vue";
import Cotizacion_Equipos from "../views/catalogos/cotizacion/equipo/List.vue";
import Cotizacion_Costokm from "../views/catalogos/cotizacion/costoskm/List.vue";
import Cotizacion_Costota from "../views/catalogos/cotizacion/costosta/List.vue";
import Cotizacion_Markup from "../views/catalogos/cotizacion/markup/List.vue";
import Cotizacion_List from "../views/modulos/cotizacion/List.vue";
import Propuestas_List from "../views/modulos/propuestas/List.vue";
import Cotizacion_Cliente from '../views/catalogos/cotizacion/opcionespropuesta/Form.vue';
import Cotizacion_Vendedor from '../views/catalogos/cotizacion/vendedor/List.vue';
// import Cotizacion_Principal from "../views/modulos/cotizacion/Principal.vue";
import Cotizacion_Principal2 from "../views/modulos/cotizacion/Principal2.vue";

import CajaChica from "../views/modulos/cajachica/index.vue";
import Registro from "../views/catalogos/cajachica/List.vue";
import Caja from "../views/catalogos/caja/List.vue";
import AsignacionCaja from "../views/catalogos/AsignacionCaja/List.vue";
import ReporteGastos from "../views/modulos/cajachica/reportegastos/list.vue";
import listagastos from "../views/modulos/cajachica/reportegastos/listgastos.vue";

import SubMenSpendplan from "../views/submenu/Spendplan.vue";
import Spend_proyecto from "../views/modulos/spendplan/proyecto/List.vue";
import Spend_proform from "../views/modulos/spendplan/proyecto/Form.vue";
import Spend_ordenc from "../views/modulos/spendplan/ordenc/List.vue";
import Spend_dashboard from "../views/modulos/spendplan/dashboard/Dashboard.vue";
import Spend_Hora from "../views/modulos/spendplan/horas/List.vue";

import DashboardDespacho from "../views/modulos/dashboard/despacho/Principal.vue";
import DashboardFinanza from "../views/modulos/dashboard/finanzas/Principal.vue";
import DashboardCrm from "../views/modulos/dashboard/crm/Principal.vue";
import DashboardPm from "../views/modulos/dashboard/pm/Principal.vue";
import DashboardCheckIn from "../views/modulos/dashboard/checkin/Principal.vue";
import DashboardVentas from "../views/modulos/dashboard/ventas/Principal.vue";
import DashboardCobranza from "../views/modulos/cobranza/VentasList.vue";

import mnufacturacion from "../views/submenu/Facturacion.vue";
import listaserfac from "../views/modulos/factura/List.vue";
import formfact from "../views/modulos/factura/Form.vue";
import ListFact from "../views/modulos/factura/ListFactura.vue";
import FacturaLibre from "../views/modulos/factura/FacturaLibre.vue";


import crm from "../views/modulos/crm/index.vue";
import Contactos from "../views/modulos/crm/contactos/list.vue";
import Contactosucursal from "../views/modulos/crm/contactosucursal/List.vue";
import Propiedades from "../views/modulos/crm/contactos/Propiedades.vue";
import oportunidad from "../views/modulos/crm/oportunidad/List.vue";
import tipoproceso from "../views/modulos/crm/tiposprocesos/List.vue";
import procesos from "../views/modulos/crm/procesos/List.vue";
import vendedores from "../views/modulos/crm/vendedores/List.vue";
import pipedrive from "../views/modulos/crm/pipedrive/List.vue";
import forecast from "../views/modulos/crm/forecast/List.vue";

import Monitoreo_cli from "../views/modulos/monitoreo/ClientesCard.vue";
import Mon_Sucursal from "../views/modulos/monitoreo/Sucursales.vue";
import Mon_Equipo from "../views/modulos/monitoreo/Equipos.vue";
import Mon_Histequipo from "../views/modulos/monitoreo/HistEquipo.vue";
import Mon_Cotizacion from "../views/modulos/monitoreo/cotizaciones/List.vue";
import Mon_Calendario from "../views/modulos/monitoreo/Calendario.vue";
import Mon_Solicitudes from "../views/modulos/monitoreo/solicitudes/List.vue";
import Mon_Evidencia from "../views/modulos/monitoreo/VisorEvidencia.vue";
import Reasignacion from "../views/modulos/monitoreo/Reasignacion.vue";
import BienvenidaCliente from "../views/modulos/monitoreo/Bienvenida.vue";

//Root
import MenusRoot from "../views/submenu/AdmonRoot.vue";
import empresasroot from "../views/catalogos/Root/Empresa/List.vue";
import sucursalroot from "../views/catalogos/Root/Sucursales/List.vue";
import usersucursal from "../views/catalogos/Root/Sucursales/ListUsuarios.vue";
import PaquetesRoot from "../views/catalogos/Root/Paquetes/Menu.vue";
import DistribuidorRoot from "../views/catalogos/Root/Distribuidores/List.vue";

import ListPaquetesMonitoreo from "../views/catalogos/Root/Paquetes/UsuariosMonitoreo/List.vue";
import ListPaquetesPropiedades from "../views/catalogos/Root/Paquetes/Propiedades/List.vue";
import ListPaquetesPropiedadesBase from "../views/catalogos/Root/Paquetes/PropiedadesBase/List.vue";
import ListPaquetesPropiedadesMonCliente from "../views/catalogos/Root/Paquetes/PropiedadesMonCliente/List.vue";
import ListPaquetesCheckIn from "../views/catalogos/Root/Paquetes/CheckIn/List.vue";

import configequipamiento from "../views/catalogos/Root/ConfigEquipos/List.vue";
import configconceptos from "../views/catalogos/Root/Conceptos/List.vue";
import ConfigCorreos from "../views/catalogos/Root/Correo/List.vue";

import OportunidadesServicios from "../views/modulos/oportunidades/index.vue";
import OportunidadesServiciosLista from "../views/modulos/oportunidades/OportunidadesList.vue";
import OportunidadesEquipos from "../views/modulos/oportunidades/OportunidadesEquipo.vue";
import Activas from "../views/modulos/oportunidades/Activas.vue";

//Finanzas
import MenusFinanzas from "../views/submenu/Finanzas.vue";
import SubMenusFinanzas from "../views/submenu/Finanzas2.vue";
//plan de ventas
import planventas from "../views/modulos/finanzas/planventas/Form.vue";
//Base actual
import baseactual from "../views/modulos/finanzas/baseactual/List.vue";
//Porcentaje operacion
import porcentajeoper from "../views/modulos/finanzas/porcentajeoperacion/Form.vue";
//Costo depto ventas
import costosventas from "../views/modulos/finanzas/costodeptoventas/Form.vue";
//Costo depto operaciones
import costooperaciones from "../views/modulos/finanzas/costodeptooper/Form.vue";
//Costo costovehope
import costovehope from "../views/modulos/finanzas/costovehope/Form.vue";
//Costo gostosga
import costoga from "../views/modulos/finanzas/costosga/Form.vue";
//Costo financieros
import costofinanciero from "../views/modulos/finanzas/costofinanciero/Form.vue";
//Costo financieros
import actcostadmin from "../views/modulos/finanzas/actcostadmin/Form.vue";
//Costo financieros
import estadofupdate from "../views/modulos/finanzas/estadofupdate/Form.vue";
//estadosfinancieros
import estadosfinancieros from "../views/modulos/finanzas/estadosfinancieros/Form.vue";
// import estadosfinancierosproyecto from "../views/modulos/finanzas/estadosfinancieros/FormProyecto.vue";
import estadosfgral from "../views/modulos/finanzas/estadosfinancieros/General.vue";
import estadosfinancierosproyecto from "../views/modulos/finanzas/estadosfinancieros/FormProyecto.vue";
import SpendProyectoMantenimiento from "../views/modulos/finanzas/estadosfinancieros/SpendProyectoMantenimiento.vue";
import ContratosFinanzas from "../views/modulos/finanzas/estadosfinancieros/ListVenta.vue";
import estadosfga from "../views/modulos/finanzas/estadosfinancieros/seccionesef/GA.vue";
import estadosfoperaciones from "../views/modulos/finanzas/estadosfinancieros/seccionesef/Operaciones.vue";
import estadosfvehiculooperaciones from "../views/modulos/finanzas/estadosfinancieros/seccionesef/VehiculoOperaciones.vue";
import estadosffinanciero from "../views/modulos/finanzas/estadosfinancieros/seccionesef/Financiero.vue";
import estadosfdeptoventa from "../views/modulos/finanzas/estadosfinancieros/seccionesef/DeptoVenta.vue";
import estadosfanual from "../views/modulos/finanzas/estadosfinancieros/Anual.vue";

//reset password
import RecoveryAccount from "../views/segurity/RecoveryAccount.vue";
import ConfirmPassword from "../views/segurity/confirmpass.vue";

//Cuentas por cobra y pagar
import menuctacobrarpagar from "../views/submenu/CtaCobrarPagar.vue";
import ctaproveedores from "../views/modulos/ctaporcobrarpagar/proveedores/List.vue";
import ctacuentasporpagaradmin from "../views/modulos/ctaporcobrarpagar/ctaporpagaradmin/List.vue";
import ctacuentasporpagaropera from "../views/modulos/ctaporcobrarpagar/ctaporpagaropera/List.vue";
import ctacuentasporcobrar from "../views/modulos/ctaporcobrarpagar/ctaporcobrar/List.vue";
import ctacuentasporcobrarnvo from "../views/modulos/ctaporcobrarpagar/ctaporcobrar/ListNvo.vue";
import pipedrive2022 from "../views/modulos/crm/pipedrive/pipedrive.vue";

//Permisos
import Cpermiso from "../views/catalogos/permiso/List.vue";
import Perfiles from "../views/catalogos/perfilesconfig/List.vue";
import AsignarPermisos from "../views/catalogos/perfilpermiso/List.vue";
import Listapaquetes from "../views/catalogos/paquete/List.vue";
import GraficaPerfiles from "../views/catalogos/perfilesgraficas/List.vue";

import NewMapa from "../views/modulos/Geolocalizacion.vue";
import GeolocalizacionCliente from "../views/modulos/crm/contactos/Geolocalizacion.vue";

//Levantamiento
import Levantamientolist from "../views/modulos/Levantamiento/List.vue";

import MailConfigService from "../views/catalogos/mailconfig/Form.vue";

import Activos from "../views/catalogos/activos/List.vue";

//PM
import MenusPM from "../views/submenu/PM.vue";
import GenerarSpendPlan from "../views/modulos/pm/SpendPlan.vue";
// import AnalisisContrato from "../views/modulos/pm/Analisis.vue";
import CheckIn from "../views/modulos/checkin/list.vue";

import CheckInDetalle from "../views/modulos/checkin/detalle.vue";
import PersonalRH from "../views/modulos/checkin/Personal.vue";

import Proyectos from "../views/modulos/proyecto/List.vue";
import ProyectosRelacionados from "../views/modulos/proyecto/ListRelacion.vue";
import ProyectoDesglose from "../views/modulos/proyecto/Detalle.vue";
import ProyectosMenu from "../views/submenu/Proyectos.vue";
import ServiceManagement from "../views/modulos/proyecto/ServiceManagement.vue";
import ProjectManagement from "../views/modulos/proyecto/ProjectManagement.vue";
import AlmacenMenu from "../views/submenu/Almacen.vue";

//ALMACEN
import Almacen from "../views/modulos/almacen/Categoria.vue";
import MaterialesAlmacen from "../views/modulos/almacen/materiales/List.vue";
import RefaccionesAlmacen from "../views/modulos/almacen/refacciones/List.vue";
import EquiposAlmacen from "../views/modulos/almacen/equipos/List.vue";

//COBRANZA
import CobranzaMenu from "../views/submenu/Cobranza.vue";
import FacturacionCobranza from "../views/modulos/cobranza/FacturacionCobranzaList.vue";
//VENTAS
import SubMenuVentas from "../views/submenu/Ventas.vue";
import Ventas from "../views/modulos/ventas/List.vue";
import FolioVenta from "../views/modulos/ventas/ListFolio.vue";
//MODULO CALENDARIO
import CalendarioIndex from "../views/modulos/calendario/index.vue";
import CalendarioVentas from "../views/modulos/calendario/ventas/index.vue";
import CalendarioOperaciones from "../views/modulos/calendario/operaciones/index.vue";
//FLOTILLA
import Flotilla from "../views/modulos/flotilla/List.vue";
import FlotillaDetalle from "../views/modulos/flotilla/Detalle.vue";
//NOMINA
import Nomina from "../views/modulos/nomina/List.vue";
import NominaForm from "../views/modulos/nomina/Form.vue";
//WEBAPP
import WebAppIndex from "../views/webapp/WebAppMenu.vue";
import WebAppHome from "../views/webapp/HomeWebApp.vue";
import WebAppListServicio from "../views/webapp/servicios/ListServicioWebApp.vue";
import WebAppServicioDetalle from "../views/webapp/servicios/ServicioDetalleWebApp.vue";
import WebAppEquiposServicio from "../views/webapp/servicios/EquiposServicioWebApp.vue";
import WebAppDatosEquipo from "../views/webapp/equipos/DatosEquipoWebApp.vue";
import WebAppManualesEquipo from "../views/webapp/equipos/ManualesEquipoWebApp.vue";
import WebAppHistorialEquipo from "../views/webapp/equipos/HistorialEquipoWebApp.vue";
import WebAppHistorialReporte from "../views/webapp/equipos/HistorialReporteWebApp.vue";
import WebAppListObservaciones from "../views/webapp/equipos/ListObservacionesWebApp.vue";
import WebAppListRefacciones from "../views/webapp/equipos/ListRefaccionesWebApp.vue";
import WebAppTareas from "../views/webapp/servicios/TareasWebApp.vue";
import WebAppFotoGeneral from "../views/webapp/servicios/FotoGeneralWebApp.vue";
import WebAppEquipoComentario from "../views/webapp/equipos/EquipoComentarioWebApp.vue";
import WebAppEstatusEquipo from "../views/webapp/equipos/EstatusEquipoWebApp.vue";
import WebAppFirma from "../views/webapp/servicios/FirmaWebApp.vue";
import WebAppListImagenes from "../views/webapp/servicios/ListImagenesWebApp.vue";
import WebAppTipoQr from "../views/webapp/servicios/TipoQrWebApp.vue";
import WebAppListGastos from "../views/webapp/gastos/ListGastosWebApp.vue";
import WebAppGastoDetalle from "../views/webapp/gastos/GastoDetalleWebApp.vue";
import WebAppAgenda from "../views/webapp/servicios/AgendaWebApp.vue";
import WebAppCheckIn from "../views/webapp/checkin/CheckInWebApp.vue";
import WebAppObservacionesCriticas from "../views/webapp/equipos/ObservacionesCriticasWebApp.vue";
import WebAppReemplazoRefaccion from "../views/webapp/equipos/ReemplazoRefaccionWebApp.vue";
//DISTRIBUIDORES
import DistribuidorClientes from '../views/modulos/distribuidor/clientes/ListCard.vue';
import DistribuidorClientesDetalle from '../views/modulos/distribuidor/clientes/Detalle.vue';
import DistribuidorAlmacen from '../views/modulos/distribuidor/almacen/SubMenu.vue';
import MaterialesAlmacenDistribuidor from '../views/modulos/distribuidor/almacen/materiales/List.vue';
import EquiposAlmacenDistribuidor from '../views/modulos/distribuidor/almacen/equipos/List.vue';
import RefaccionesAlmacenDistribuidor from '../views/modulos/distribuidor/almacen/refacciones/List.vue';
import DistribuidorSolicitudes from '../views/modulos/distribuidor/solicitudes/List.vue';
Vue.use(VueRouter);

const routes = [
	{
		path: "/",
		name: "Login",
		component: Login,
		props: true,
		meta: {
			stylesheet: 'desprosoft'
		  }
	},
	{
		path: "/recoveryaccount",
		name: "recoveryaccount",
		component: RecoveryAccount
	},
	{
		path: "/FormConfirm/:user/:tkn",
		name: "confirmpassword",
		component: ConfirmPassword,
		props: true
		//props:{ prop1: '' }
	},
	{
		path: "/bienvenidacliente",
		name: "bienvenidacliente",
		component: BienvenidaCliente,
		props: true
		//props:{ prop1: '' }
	},

	{
		path: "/admin",
		name: "AdminInicio",
		component: AdminTemplate,
		props: true,
		meta: {
			requiresAuth: true,
			stylesheet: 'desprosoft'
		},
		children: [
			{
				path: "/usuarios",
				name: "usuarios",
				component: Usuarios,
				props: true
			},
			{
				path: "/asignacioncaja",
				name: "asignacioncaja",
				component: AsignacionCaja,
				props: true
			},
			{
				path: "/categoriavehiculo",
				name: "categoriavehiculo",
				component: CategoriaVehiculo,
				props: true
			},
			{
				path: "/caja",
				name: "caja",
				component: Caja,
				props: true
			},
			{
				path: "/reportegastos",
				name: "reportegastos",
				component: ReporteGastos,
				props: true
			},
			{
				path: "/listagastos",
				name: "listagastos",
				component: listagastos,
				props: true
			},
			{
				path: "/registro",
				name: "registro",
				component: Registro,
				props: true
			},
			{
				path: "/servicio",
				name: "servicio",
				component: Servicio
			},
			{
				path: "/cajachica",
				name: "cajachica",
				component: CajaChica,
				props: true
			},
			{
				path: "/equipamiento",
				name: "equipamiento",
				component: Equipamiento
			},
			{
				path: "/concepto",
				name: "concepto",
				component: Concepto,
				props: true
			},
			{
				path: "/equipos",
				name: "equipos",
				component: Equipos,
				props: true
			},
			{
				path: "/sucursal",
				name: "sucursal",
				component: Sucursal,
				props: true
			},
			{
				path: "/usuarios/form",
				name: "usuariosForm",
				component: FormUser,
				props: true
			},
			{
				path: "/clientes",
				name: "clientes",
				component: Clientes,
				props: true
			},
			{
				path: "/empresas",
				name: "empresas",
				component: EmpresaLista,
				props: true
			},
			{
				path: "/horaslaborales",
				name: "horaslaborales",
				component: HorasLaborales,
				props: true
			},
			{
				path: "/personal",
				name: "personal",
				component: Personal,
				props: true
			},
			{
				path: "/tipounidad",
				name: "tipounidad",
				component: TipoUnidad,
				props: true
			},
			{
				path: "/tiposervicio",
				name: "tiposervicio",
				component: TipoServicio,
				props: true
			},
			{
				path: "/folio",
				name: "folio",
				component: Folio,
				props: true
			},
			{
				path: "/categoriapersonal",
				name: "categoriapersonal",
				component: CategoriaPersonal,
				props: true
			},
			{
				path: "/vehiculo",
				name: "vehiculo",
				component: Vehiculo,
				props: true
			},
			{
				path: "/clientesucursal",
				name: "clientesucursal",
				component: ClienteSucursal,
				props: true
			},
			{
				path: "/contratoclientesucursal",
				name: "contratoclientesucursal",
				component: ContratoClienteSucursal,
				props: true
			},
			{
				path: "/listusu",
				name: "listusu",
				component: ListUsu,
				props: true
			},
			{
				path: "/pdfequipo",
				name: "pdfequipo",
				component: PdfEquipo,
				props: true
			},
			{
				path: "/despacho",
				name: "despacho",
				component: Despacho,
				props: true
			},
			{
				path: "/despachoform",
				name: "despachoform",
				component: ServicioForm,
				props: true
			},
			{
				path: "/mapa",
				name: "Mapa",
				component: Mapa,
				props: true
			},
			{
				path: "/calendar",
				name: "calendar",
				component: calendar,
				props: true
			},
			{
				path: "/submenuadmon",
				name: "submenuadmon",
				component: SubmenuAdmon
			},
			{
				path: "/costosvarios",
				name: "costosvarios",
				component: CostosVarios,
				props: true
			},
			{
				path: "/submenucotizacion",
				name: "submenucotizacion",
				component: SubmenuCotizacion,
				props: true
			},
			{
				path: "/cotizacion_materiales",
				name: "cotizacion_materiales",
				component: Cotizacion_Materiales,
				props: true
			},
			{
				path: "/cotizacion_equipos",
				name: "cotizacion_equipos",
				component: Cotizacion_Equipos,
				props: true
			},
			{
				path: "/cotizacion_costoskm",
				name: "cotizacion_costoskm",
				component: Cotizacion_Costokm,
				props: true
			},
			{
				path: "/cotizacion_costosta",
				name: "cotizacion_costosta",
				component: Cotizacion_Costota,
				props: true
			},
			{
				path: "/cotizacion_markup",
				name: "cotizacion_markup",
				component: Cotizacion_Markup,
				props: true
			},
			{
				path: "/cotizacion_vendedor",
				name: "cotizacion_vendedor",
				component: Cotizacion_Vendedor,
				props: true
			},
			{
				path: "/cotizacion_list",
				name: "cotizacion_list",
				component: Cotizacion_List,
				props: true
			},
			{
				path: "/propuestas_list",
				name: "propuestas_list",
				component: Propuestas_List,
				props: true
			},
			{
				path: "/terminos",
				name: "terminos",
				component: Cotizacion_Cliente,
				props: true
			},
			{
				path: "/cotizacion_principal",
				name: "cotizacion_principal",
				component: Cotizacion_Principal2,
				props: true
			},
			// {
			// 	path: "/cotizacion_principal2",
			// 	name: "cotizacion_principal2",
			// 	component: Cotizacion_Principal2,
			// 	props: true
			// },
			{
				path: "/listservicio",
				name: "listservicio",
				component: ListServicio,
				props: true
			},
			{
				path: "/spendplan",
				name: "spendplan",
				component: SubMenSpendplan,
				props: true
			},
			{
				path: "/spend_proyecto",
				name: "spend_proyecto",
				component: Spend_proyecto,
				props: true
			},
			{
				path: "/spend_proform",
				name: "spend_proform",
				component: Spend_proform,
				props: true
			},
			{
				path: "/spend_ordenc",
				name: "spend_ordenc",
				component: Spend_ordenc,
				props: true
			},
			{
				path: "/spend_hora",
				name: "spend_hora",
				component: Spend_Hora,
				props: true
			},
			{
				path: "/spend_dashboard",
				name: "spend_dashboard",
				component: Spend_dashboard,
				props: true
			},
			{
				path: "/dashboarddespacho",
				name: "dashboarddespacho",
				component: DashboardDespacho,
				props: true
			},
			{
				path: "/dashboardfinanza",
				name: "dashboardfinanza",
				component: DashboardFinanza,
				props: true
			},
			{
				path: "/dashboardcrm",
				name: "dashboardcrm",
				component: DashboardCrm,
				props: true
			},
			{
				path: "/dashboardpm",
				name: "dashboardpm",
				component: DashboardPm,
				props: true
			},
			{
				path: "/dashboardcheckin",
				name: "dashboardcheckin",
				component: DashboardCheckIn,
				props: true
			},
			{
				path: "/dashboardventas",
				name: "dashboardventas",
				component: DashboardVentas,
				props: true
			},
			{
				path: "/ventascobranza",
				name: "dashboardcobranza",
				component: DashboardCobranza,
				props: true
			},
			{
				path: "/monitoreo_cli",
				name: "monitoreo_cli",
				component: Monitoreo_cli,
				props: true
			},
			{
				path: "/mon_sucursal",
				name: "mon_sucursal",
				component: Mon_Sucursal,
				props: true
			},
			{
				path: "/mon_equipo",
				name: "mon_equipo",
				component: Mon_Equipo,
				props: true
			},
			{
				path: "/mon_histequipo",
				name: "mon_histequipo",
				component: Mon_Histequipo,
				props: true
			},
			{
				path: "/mon_cotizacion",
				name: "mon_cotizacion",
				component: Mon_Cotizacion,
				props: true
			},
			{
				path: "/mon_reporte",
				name: "mon_reporte",
				component: Mon_Cotizacion,
				props: true
			},
			{
				path: "/mon_calendario",
				name: "mon_calendario",
				component: Mon_Calendario,
				props: true
			},
			{
				path: "/mon_solicitudes",
				name: "mon_solicitudes",
				component: Mon_Solicitudes,
				props: true
			},
			{
				path: "/mon_evidencia",
				name: "mon_evidencia",
				component: Mon_Evidencia,
				props: true
			},
			{
				path: "/reasignacion",
				name: "reasignacion",
				component: Reasignacion,
				props: true
			},
			//Factura
			{
				path: "/submenufact",
				name: "submenufact",
				component: mnufacturacion,
				props: true
			},
			{
				path: "/listaserfac",
				name: "listaserfac",
				component: listaserfac,
				props: true
			},
			{
				path: "/formfact",
				name: "formfact",
				component: formfact,
				props: true
			},
			{
				path: "/ListFacturas",
				name: "ListFacturas",
				component: ListFact,
				props: true
			},
			{
				path: "/FacturaLibre",
				name: "FacturaLibre",
				component: FacturaLibre,
				props: true
			},

			,
			//crm
			{
				path: "/submenucrm",
				name: "submenucrm",
				component: crm,
				props: true
			},
			{
				path: "/crmcontactos",
				name: "crmcontactos",
				component: Contactos,
				props: true
			},
			{
				path: "/crmcontactosucursal",
				name: "crmcontactosucursal",
				component: Contactosucursal,
				props: true
			},
			{
				path: "/crmoportunidad",
				name: "crmoportunidad",
				component: oportunidad,
				props:true
			},
			{
				path: "/crmtiposprocesos",
				name: "crmtiposprocesos",
				component: tipoproceso,
				props: true
			},
			{
				path: "/crmprocesos",
				name: "crmprocesos",
				component: procesos,
				props: true
			},
			{
				path: "/crmvendedores",
				name: "crmvendedores",
				component: vendedores,
				props: true
			},
			{
				path: "/crmpipedrive",
				name: "crmpipedrive",
				component: pipedrive2022,
				props: true
			},
			{
				path: "/crmforecast",
				name: "crmforecast",
				component: forecast,
				props: true
			},
			{
				path: "/pipedrive2022",
				name: "pipedrive2022",
				component: pipedrive2022,
				props: true
			},
			//MenusFinanzas
			{
				path: "/MenusFinanzas",
				name: "MenusFinanzas",
				component: MenusFinanzas,
				props: true
			},
			,
			{
				path: "/SubMenusFinanzas",
				name: "SubMenusFinanzas",
				component: SubMenusFinanzas,
				props: true
			},
			{
				path: "/planventas",
				name: "planventas",
				component: planventas,
				props: true
			},
			{
				path: "/baseactual",
				name: "baseactual",
				component: baseactual,
				props: true
			},
			,
			{
				path: "/porcentajeoper",
				name: "porcentajeoper",
				component: porcentajeoper,
				props: true
			},
			{
				path: "/costosventas",
				name: "costosventas",
				component: costosventas,
				props: true
			},
			{
				path: "/costooperaciones",
				name: "costooperaciones",
				component: costooperaciones,
				props: true
			},
			{
				path: "/costovehope",
				name: "costovehope",
				component: costovehope,
				props: true
			},
			{
				path: "/costoga",
				name: "costoga",
				component: costoga,
				props: true
			},
			{
				path: "/costofinanciero",
				name: "costofinanciero",
				component: costofinanciero,
				props: true
			},
			{
				path: "/actcostadmin",
				name: "actcostadmin",
				component: actcostadmin,
				props: true
			},
			{
				path: "/estadofupdate",
				name: "estadofupdate",
				component: estadofupdate,
				props: true
			},
			{
				path: "/estadosfinancieros",
				name: "estadosfinancieros",
				component: estadosfinancieros,
				props: true
			},
			{
				path: "/estadosfinancierosproyecto",
				name: "estadosfinancierosproyecto",
				component: estadosfinancierosproyecto,
				props: true
			},
			{
				path: "/crearspendplan",
				name: "crearspendplan",
				component: ContratosFinanzas,
				props: true
			},
			{
				path: "/spendproyectomantenimiento",
				name: "spendproyectomantenimiento",
				component: SpendProyectoMantenimiento,
				props: true
			},
			{
				path: "/estadosfgral",
				name: "estadosfgral",
				component: estadosfgral,
				props: true
			},
			{
				path: "/estadosfga",
				name: "estadosfga",
				component: estadosfga,
				props: true
			},
			{
				path: "/estadosfoperaciones",
				name: "estadosfoperaciones",
				component: estadosfoperaciones,
				props: true
			},
			{
				path: "/estadosfvehiculooperaciones",
				name: "estadosfvehiculooperaciones",
				component: estadosfvehiculooperaciones,
				props: true
			},
			{
				path: "/estadosffinanciero",
				name: "estadosffinanciero",
				component: estadosffinanciero,
				props: true
			},
			{
				path: "/estadosfdeptoventa",
				name: "estadosfdeptoventa",
				component: estadosfdeptoventa,
				props: true
			},
			{
				path: "/estadosfanual",
				name: "estadosfanual",
				component: estadosfanual,
				props: true
			},
			{
				path: "/estadosfinancierosproyecto",
				name: "estadosfinancierosproyecto",
				component: estadosfinancierosproyecto,
				props: true
			},
			{
				path: "/crearspendplan",
				name: "crearspendplan",
				component: ContratosFinanzas,
				props: true
			},
			{
				path: "/spendproyectomantenimiento",
				name: "spendproyectomantenimiento",
				component: SpendProyectoMantenimiento,
				props: true
			},

			{
				path: "/menuctacobrarpagar",
				name: "menuctacobrarpagar",
				component: menuctacobrarpagar,
				props: true
			},
			{
				path: "/ctaproveedores",
				name: "ctaproveedores",
				component: ctaproveedores,
				props: true
			},
			{
				path: "/ctacuentasporcobrar",
				name: "ctacuentasporcobrar",
				component: ctacuentasporcobrarnvo,
				props: true
			},
			// {
			// 	path: "/ctacuentasporcobrarnvo",
			// 	name: "ctacuentasporcobrarnvo",
			// 	component: ctacuentasporcobrarnvo,
			// 	props: true
			// },
			{
				path: "/cpermiso",
				name: "cpermiso",
				component: Cpermiso,
				props: true
			},
			{
				path: "/menulevantamiento",
				name: "menulevantamiento",
				component: Levantamientolist,
				props: true
			},
			{
				path: "/permisos",
				name: "perfiles",
				component: Perfiles,
				props: true
			},
			{
				path: "/permisosgraficas",
				name: "graficasperfiles",
				component: GraficaPerfiles,
				props: true
			},
			{
				path: "/asignarpermisos",
				name: "asignarpermisos",
				component: AsignarPermisos,
				props: true
			},
			{
				path: "/paquetes",
				name: "paquetes",
				component: Listapaquetes,
				props: true
			},
			{
				path: "/Geolocalizacion",
				name: "Geolocalizacion",
				component: NewMapa,
				props: true
			},
			{
				path: "/GeolocalizacionCliente",
				name: "GeolocalizacionCliente",
				component: GeolocalizacionCliente,
				props: true
			},
			{
				path: "/cuentasporpagaradmin",
				name: "cuentasporpagaradmin",
				component: ctacuentasporpagaradmin,
				props: true
			},
			{
				path: "/cuentasporpagaropera",
				name: "cuentasporpagaropera",
				component: ctacuentasporpagaropera,
				props: true
			},
			{
				path: "/mailconfigservice",
				name: "mailconfigservice",
				component: MailConfigService,
				props: true
			},
			{
				path: "/activos",
				name: "activos",
				component: Activos,
				props: true
			},
			{
				path: "/oportunidadesservicio",
				name: "oportunidadesservicio",
				component: OportunidadesServicios,
				props: true
			},
			{
				path: "/oportunidadesserviciolista",
				name: "oportunidadesserviciolista",
				component: OportunidadesServiciosLista,
				props: true
			},
			{
				path: "/activas",
				name: "activas",
				component: Activas,
				props: true
			},
			{
				path: "/oportunidadesequipo",
				name: "oportunidadesequipo",
				component: OportunidadesEquipos,
				props: true
			},
			{
				path: "/propiedades",
				name: "propiedades",
				component: Propiedades,
				props: true
			},
			{
				path: "/MenusPM",
				name: "menuspm",
				component: MenusPM,
				props: true
			},
			{
				path: "/GenerarSpendPlan",
				name: "generarspendplan",
				component: GenerarSpendPlan,
				props: true
			},
			{
				path: "/CheckIn",
				name: "checkin",
				component: CheckIn,
				props: true
			},
			{
				path: "/CheckInDetalle",
				name: "checkindetalle",
				component: CheckInDetalle,
				props: true
			},
			{
				path: "/personalrh",
				name: "personalrh",
				component: PersonalRH,
				props: true
			},
			{
				path: "/SubMenuProyectos",
				name: "proyectos",
				component: ProyectosMenu,
				props: true
			},
			{
				path: "/servicemanagement",
				name: "servicemanagement",
				component: ServiceManagement,
				props: true
			},
			{
				path: "/projectmanagement",
				name: "projectmanagement",
				component: ProjectManagement,
				props: true
			},
			{
				path: "/oportunidadesequipo",
				name: "oportunidadesequipo",
				component: OportunidadesEquipos,
				props: true
			},

			{
				path: "/SubMenuAlmacen",
				name: "almacen",
				component: AlmacenMenu,
				props: true
			},
			{
				path: "/Almacen",
				name: "almacencategoria",
				component: Almacen,
				props: true
			},
			{
				path: "/proyectos",
				name: "proyectoslist",
				component: Proyectos,
				props: true
			},
			{
				path: "/proyectosrelacionados",
				name: "proyectosrelacionados",
				component: ProyectosRelacionados,
				props: true
			},
			{
				path: "/proyectodesglose",
				name: "proyectodesglose",
				component: ProyectoDesglose,
				props: true
			},
			{
				path: "/materialesalmacen",
				name: "materialesalmacen",
				component: MaterialesAlmacen,
				props: true
			},
			{
				path: "/refaccionesalmacen",
				name: "refaccionesalmacen",
				component: RefaccionesAlmacen,
				props: true
			},
			{
				path: "/equiposalmacen",
				name: "equiposalmacen",
				component: EquiposAlmacen,
				props: true
			},
			{
				path: "/menucobranza",
				name: "menucobranza",
				component: CobranzaMenu,
				props: true
			},
			{
				path: "/facturacioncobranza",
				name: "facturacioncobranza",
				component: FacturacionCobranza,
				props: true
			},
			{
				path: "/ventas",
				name: "ventas",
				component: Ventas,
				props: true
			},
			{
				path: "/submenuventas",
				name: "submenuventas",
				component: SubMenuVentas,
				props: true
			},
			{
				path: "/foliocontrato",
				name: "foliocontrato",
				component: FolioVenta,
				props: true
			},
			{
				path: "/calendarioventas",
				name: "calendarioventas",
				component: CalendarioVentas,
				props: true
			},
			{
				path: "/calendariooperaciones",
				name: "calendariooperaciones",
				component: CalendarioOperaciones,
				props: true
			},
			{
				path: "/calendario",
				name: "calendario",
				component: CalendarioIndex,
				props: true
			},
			{
				path: "/flotilla",
				name: "flotilla",
				component: Flotilla,
				props: true
			},
			{
				path: "/vehiculoinfo",
				name: "flotilladetalle",
				component: FlotillaDetalle,
				props: true
			},
			{
				path: "/nomina",
				name: "nomina",
				component: Nomina,
				props: true
			},
			{
				path: "/nominaform",
				name: "nominaform",
				component: NominaForm,
				props: true
			},
			{
				path: "/distribuidorcliente",
				name: "distribuidorcliente",
				component: DistribuidorClientes,
				props: true
			},
			{
				path: "/distribuidorclienteinfo",
				name: "distribuidorclienteinfo",
				component: DistribuidorClientesDetalle,
				props: true
			},
			{
				path: "/distribuidorsolicitud",
				name: "distribuidorsolicitud",
				component: DistribuidorSolicitudes,
				props: true
			},
			{
				path: "/distribuidoralmacen",
				name: "distribuidoralmacen",
				component: DistribuidorAlmacen,
				props: true
			},
			{
				path: "/materialesalmacendistribuidor",
				name: "materialesalmacendistribuidor",
				component: MaterialesAlmacenDistribuidor,
				props: true
			},
			{
				path: "/equiposalmacendistribuidor",
				name: "equiposalmacendistribuidor",
				component: EquiposAlmacenDistribuidor,
				props: true
			},
			{
				path: "/refaccionesalmacendistribuidor",
				name: "refaccionesalmacendistribuidor",
				component: RefaccionesAlmacenDistribuidor,
				props: true
			},
			// {
			// 	path: "/AnalisisContrato",
			// 	name: "analisiscontrato",
			// 	component: AnalisisContrato,
			// 	props: true
			// }

		]
	},
	{
		path: "/root/",
		name: "RootInicio",
		component: AdminTemplate,
		meta: {
			requiresAuth: true,
			stylesheet: 'desprosoft'
		},
		children: [
			{
				path: "/MenusRoot",
				name: "MenusRoot",
				component: MenusRoot,
				props: true
			},
			{
				path: "/empresasroot",
				name: "empresasroot",
				component: empresasroot,
				props: true
			},
			{
				path: "/sucursalroot",
				name: "sucursalroot",
				component: sucursalroot,
				props: true
			},
			{
				path: "/usersucursal",
				name: "usersucursal",
				component: usersucursal,
				props: true
			},
			{
				path: "/configequipamiento",
				name: "configequipamiento",
				component: configequipamiento,
				props: true
			},
			{
				path: "/configconceptos",
				name: "configconceptos",
				component: configconceptos,
				props: true
			},
			{
				path: "/ConfigCorreos",
				name: "ConfigCorreos",
				component: ConfigCorreos,
				props: true
			},
			{
				path: "/ConfigPaquetes",
				name: "ConfigPaquetes",
				component: PaquetesRoot,
				props: true
			},
			{
				path: "/ConfigDistribuidor",
				name: "ConfigDistribuidor",
				component: DistribuidorRoot,
				props: true
			},
			{
				path: "/ListPaquetesMonitoreo",
				name: "ListPaquetesMonitoreo",
				component: ListPaquetesMonitoreo,
				props: true
			},
			{
				path: "/ListPaquetesPropiedadesMonInterno",
				name: "ListPaquetesPropiedades",
				component: ListPaquetesPropiedades,
				props: true
			},
			{
				path: "/ListPaquetesPropiedades",
				name: "ListPaquetesPropiedadesBase",
				component: ListPaquetesPropiedadesBase,
				props: true
			},
			{
				path: "/ListPaquetesPropiedadesMonCliente",
				name: "ListPaquetesPropiedadesMonCliente",
				component: ListPaquetesPropiedadesMonCliente,
				props: true
			},
			{
				path: "/ListPaquetesCheckIn",
				name: "ListPaquetesCheckIn",
				component: ListPaquetesCheckIn,
				props: true
			},
		]
	},
	{
		path:'/WebApp/',
		name:'WebApp',
		component:WebAppIndex,
		meta:{
			requiresAuth:true,
			stylesheet: 'webapp'
		},
		children:[
			{
				path: "/HomeWebApp",
				name: "HomeWebApp",
				component: WebAppHome,
				props: true,
				meta:{
					stylesheet: 'webapp'
				},
			},
			{
				path: "/ServiciosWebApp",
				name: "ServiciosWebApp",
				component: WebAppListServicio,
				props: true
			},
			{
				path: "/ServicioDetalleWebApp",
				name: "ServicioDetalleWebApp",
				component: WebAppServicioDetalle,
				props: true
			},
			{
				path: "/EquiposServicioWebApp",
				name: "EquiposServicioWebApp",
				component: WebAppEquiposServicio,
				props: true
			},
			{
				path: "/DatosEquipoWebApp",
				name: "DatosEquipoWebApp",
				component: WebAppDatosEquipo,
				props: true
			},
			{
				path: "/ManualesEquipoWebApp",
				name: "ManualesEquipoWebApp",
				component: WebAppManualesEquipo,
				props: true
			},
			{
				path: "/HistorialEquipoWebApp",
				name: "HistorialEquipoWebApp",
				component: WebAppHistorialEquipo,
				props: true
			},
			{
				path: "/HistorialReporteWebApp",
				name: "HistorialReporteWebApp",
				component: WebAppHistorialReporte,
				props: true
			},
			{
				path: "/ListObservacionesWebApp",
				name: "ListObservacionesWebApp",
				component: WebAppListObservaciones,
				props: true
			},
			{
				path: "/ListRefaccionesWebApp",
				name: "ListRefaccionesWebApp",
				component: WebAppListRefacciones,
				props: true
			},
			{
				path: "/TareasWebApp",
				name: "TareasWebApp",
				component: WebAppTareas,
				props: true
			},
			{
				path: "/FotoGeneralWebApp",
				name: "FotoGeneralWebApp",
				component: WebAppFotoGeneral,
				props: true
			},
			{
				path: "/EquipoComentarioWebApp",
				name: "EquipoComentarioWebApp",
				component: WebAppEquipoComentario,
				props: true
			},
			{
				path: "/EstatusEquipoWebApp",
				name: "EstatusEquipoWebApp",
				component: WebAppEstatusEquipo,
				props: true
			},
			{
				path: "/FirmaWebApp",
				name: "FirmaWebApp",
				component: WebAppFirma,
				props: true
			},
			{
				path: "/ListImagenesWebApp",
				name: "ListImagenesWebApp",
				component: WebAppListImagenes,
				props: true
			},
			{
				path: "/TipoQrWebApp",
				name: "TipoQrWebApp",
				component: WebAppTipoQr,
				props: true
			},
			{
				path: "/ListGastosWebApp",
				name: "ListGastosWebApp",
				component: WebAppListGastos,
				props: true
			},
			{
				path: "/GastoDetalleWebApp",
				name: "GastoDetalleWebApp",
				component: WebAppGastoDetalle,
				props: true
			},
			{
				path: "/AgendaWebApp",
				name: "AgendaWebApp",
				component: WebAppAgenda,
				props: true
			},
			{
				path: "/CheckInWebApp",
				name: "CheckInWebApp",
				component: WebAppCheckIn,
				props: true
			},
			{
				path: "/ObservacionesCriticasWebApp",
				name: "ObservacionesCriticasWebApp",
				component: WebAppObservacionesCriticas,
				props: true
			},
			{
				path: "/ReemplazoRefaccionWebApp",
				name: "ReemplazoRefaccionWebApp",
				component: WebAppReemplazoRefaccion,
				props: true
			},
		]
	}
];

const router = new VueRouter({
	mode: 'history',
	routes
});

router.beforeEach((to, from, next) => {
	// const stylesheets = {
	// 	desprosoft: "/src/style/css/main.css",
	// 	webapp: "/style/css/mainwebapp.css",
	// };
	// const cssElement = document.getElementById("stylesheet");
	// const defaultStylesheet = stylesheets.desprosoft;

	// cssElement.href = stylesheets[to.meta.stylesheet] == undefined ? defaultStylesheet : stylesheets[to.meta.stylesheet];

	if (to.matched.some(record => record.meta.requiresAuth)) {
		if (store.getters.isLoggedIn) {
			//console.log(to.name);
			var datos = JSON.parse(sessionStorage.getItem("user"));
			var listaPaquetes = datos.listaPaquetes;

			//console.log(datos);
            //console.log(to.name);
            //console.log(to);

			var keymenu = to.name;
			if (keymenu == "despacho") {
				keymenu = "Despacho";
			} else if (keymenu == "cajachica") {
				keymenu = "Caja Chica";
			} else if (keymenu == "clientes") {
				//este menu recipe un parametro para diferenciar de otro contenido
				var TipoList = JSON.parse(sessionStorage.getItem("IdSaved"));
				if (to.params.tipolistp == "Scanning") {
					keymenu = "Scan";
				} else if (TipoList == "Scanning") {
					keymenu = "Scan";
				}
				if (to.params.tipolistp == "clientes") {
					keymenu = "otro";
				} else if (TipoList == "clientes") {
					keymenu = "otro";
				}
			} else if (keymenu == "monitoreo_cli") {
				keymenu = "Monitoreo";
			} else if (keymenu == "submenucotizacion") {
				keymenu = "Cotizacion";
			} else if (keymenu == "submenufact") {
				keymenu = "Facturacion";
			} else if (keymenu == "submenucrm") {
				keymenu = "CRM";
			} //no existe aun
			else if (keymenu == "MenusFinanzas") {
				keymenu = "Finanzas";
			} else if (keymenu == "spendplan") {
				keymenu = "Spend Plan";
			} else {
				//es un submenu no tiene permisos
				keymenu = "otro";
			}

			var arrresul = listaPaquetes.filter(function(item) {
				return item.Paquete == keymenu;
			});

			if (arrresul.length > 0) {
				//tiene permiso al menu
				next();
			} else if (
				keymenu == "AdminInicio" ||
				keymenu == "submenuadmon" ||
				keymenu == "otro"
			) {
				next();
			}

			/*
			* VALIDACIÓN PARA EVITAR RETORNO A LAS RUTAS DEL PERFIL ROOT CON EL RETROCESO DEL NAVEGADOR.
			* ANEX: 30-ENE-2023
			*
			* */
			const menuRoot = ['root','MenusRoot','empresasroot','sucursalroot','usersucursal','configequipamiento','configconceptos','ConfigCorreos'];
			if(menuRoot.includes(to.name) && parseInt(datos.IdPerfil) !== 1) {
				//console.log('ruta root, pero no el usuario no es root')
				next("/despacho");
			}else {
				/*if(menuRoot.includes(to.name)) {
					console.log('rutas de root');
				}else {
					console.log('No es ruta root');
				}*/
				next();
			}

			return;
		}
		next("/");
		console.log("debes iniciar session");
	} else {
		next();
	}
});

export default router;
